module.exports = __webpack_public_path__ + "static/media/default_card.ae8b868b.svg";